export function sayHello() {
  console.log('Noahs pro loaded!');
}